import SectionContainer from '@/components/container/SectionContainer'
import { Paragraph, SectionTitle, SubTitle } from '@/components/text'
import { useTranslation } from 'react-i18next'
import Brave from '@/assets/logos/brave.svg?react'
import DotChain from '@/assets/logos/dot_chain.svg?react'
import { motion } from 'framer-motion'
import { ClientOnly } from '@tanstack/react-router'

export const IntegrationSection = () => {
  const { t } = useTranslation()

  const fadeUp = {
    hidden: { opacity: 0, y: 22 },
    visible: (i: number) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: 'easeOut', delay: i * 0.15 },
    }),
  }

  return (
    <SectionContainer
      as="section"
      className="flex flex-col sm:flex-row justify-center items-center gap-6"
    >
      <div className="flex flex-col w-full gap-4 tablet:gap-6">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          variants={fadeUp}
          custom={0}
        >
          <SubTitle
            title={`${t('systems.bpla.integration.title')}`}
            className="text-left font-bold w-full block tablet:hidden"
          />
          <SectionTitle
            title={`${t('systems.bpla.integration.title')}`}
            className="text-left w-full hidden tablet:block"
          />
        </motion.div>

        <motion.div
          className="flex justify-end"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          variants={fadeUp}
          custom={1}
        >
          <Paragraph
            variant="grey"
            className="max-w-[540px] desktop:max-w-[630px] block"
          >
            {t('systems.bpla.integration.paragraphs.0')}{' '}
            <a
              href="https://market-brave1.delta.mil.gov.ua/pegasus-arms-25-bpla/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block underline decoration-[#FF6600] decoration-1 underline-offset-1 bg-gradient-to-r from-[#CE4906] via-[#FF6600] to-[#FF8B20] bg-clip-text text-transparent"
            >
              {t('systems.bpla.integration.link')}
            </a>{' '}
            {t('systems.bpla.integration.paragraphs.1')}
          </Paragraph>
        </motion.div>
      </div>

      {/* === ЛОГОТИПИ (анімація додана, стилі НЕ чіпаю) === */}
      <motion.div
        className="flex flex-col gap-6"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.35 }}
        variants={fadeUp}
        custom={2}
      >
        {/* BRAVE — інтерактив + акцент + hover */}
        <motion.a
          href="https://market-brave1.delta.mil.gov.ua/pegasus-arms-25-bpla/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ cursor: 'pointer' }}
          initial={{ filter: 'drop-shadow(0px 0px 0px rgba(0,0,0,0))' }} // ← базовий стан (без неону)
          whileHover={{
            scale: 1.06,
            filter: 'drop-shadow(0px 0px 12px rgba(255,102,0,0.45))', // ← неон тільки під час hover
            transition: { duration: 0.25, ease: 'easeOut' },
          }}
          whileTap={{ scale: 0.98 }}
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.88 }}
            animate={{ opacity: 1, scale: 1.2 }}
            transition={{ duration: 0.55, ease: 'easeOut' }}
          >
            <ClientOnly>
              <Brave />
            </ClientOnly>
          </motion.div>
        </motion.a>

        {/* DOTCHAIN — просте fade-up, без акценту */}
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.45, ease: 'easeOut', delay: 0.2 }}
        >
          <ClientOnly>
            <DotChain className="scale-[1.1]" />
          </ClientOnly>
        </motion.div>
      </motion.div>
    </SectionContainer>
  )
}
